<template>
  <div class="model-list">
    <div class="header pretrain-header">
      <h3 class="title">
        <span
          :class="[display === 'version' ? 'go-model' : '']"
          :title="display === 'version' ? '返回我的模型列表' : ''"
          @click="display = 'model'"
          >我的模型</span
        >
        <span
          class="modelName-span"
          :title="Model.records&&Model.records[activeModel]&&Model.records[activeModel].modelName || ''"
          v-if="display === 'version'"
        >
          <i class="el-icon-arrow-right"></i>
          {{ Model.records&&Model.records[activeModel]&&Model.records[activeModel].modelName ? Model.records[activeModel].modelName : '' }}
        </span>
      </h3>
      <div class="tools" v-if="display === 'model'">
        <el-input
          placeholder="请输入模型名称"
          v-model.trim="key"
          @keyup.enter.native="searchByModelName"
        >
          <i slot="suffix" class="icon-search-box" @click="searchByModelName">
            <icon-base class="icon-search" v-bind="Icons.search">
              <icon-search class="clr_b4bbcb" />
            </icon-base>
          </i>
        </el-input>
        <!-- <button class="btn-create" @click="createModel"></button> -->
        <span class="btn-create" @click="createModel"><i class="el-icon-circle-plus-outline"></i>创建模型</span>
      </div>
    </div>
    <div class="main">
      <table class="tb-models" v-show="display === 'model'">
        <thead class="tb-head">
          <tr class="tb-head-r">
            <th class="tb-name">模型名称</th>
            <th class="tb-edition">版本数</th>
            <th class="tb-action">操作</th>
          </tr>
        </thead>
        <tbody class="tb-body">
          <tr class="tb-body-r" v-for="(item, idx) in Model.records" :key="idx">
            <td class="tb-name" :title="item.modelName">{{ item.modelName }}</td>
            <td class="tb-edition">
              <a
                :class="[
                  'edition',
                  item.versionNum <= 0 || isNaN(item.versionNum) ? 'off' : ''
                ]"
                href="javascript:void(0);"
                @click="versionVisible(item.modelId, idx)"
              >
                {{ item.versionNum | striping }}
              </a>
            </td>
            <td class="tb-action">
              <el-dropdown @command="trainingCommand">
                <span class="el-dropdown-link">
                  训练
                  <i class="el-icon-caret-bottom el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="['training', item.modelId]"
                    >训练</el-dropdown-item
                  >
                  <el-dropdown-item
                    :command="['verify', item.modelId]"
                    :class="
                      item.versionNum <= 0 || isNaN(item.versionNum)
                        ? 'off'
                        : ''
                    "
                    >校验</el-dropdown-item
                  >
                  <el-dropdown-item
                    :command="['release', item.modelId]"
                    :class="
                      item.versionNum <= 0 || isNaN(item.versionNum)
                        ? 'off'
                        : ''
                    "
                    >发布</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <span class="sep"></span>
              <button
                class="btn-opt btn-edite"
                @click="activeUpdatePopup(item.modelId, idx)"
              >
                <i class="icon_box icon-edi"></i>
              </button>
              <span class="sep"></span>

              <button
                class="btn-opt btn-del"
                @click="activeDeletePopup(item.modelId, idx)"
              >
                <i class="icon_box icon-del"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="model-version" v-show="display === 'version'">
        <div
          class="version-list"
          v-for="(item, idx) in TrainingModel.records"
          :key="item.trainModelId || idx"
        >
          <dl class="meta">
            <dt><b>版本:</b></dt>
            <dd>
              <b>{{ item.version }}</b>
            </dd>
          </dl>
          <dl class="meta" v-if="item.trainModelStatus == 3">
            <dt>模型ID:</dt>
            <dd>{{item.algorithmId}}</dd>
          </dl>
          <dl class="meta" v-if="item.reportData">
            <!-- 图像识别：{"mAP":0.01}
                图像分类：{"Accuracy":0.01} -->
            <!-- <template v-if="modelType === '1'">
              <dt>准确率:</dt>
              <dd>{{ JSON.parse(item.reportData).Accuracy | toPercent }}</dd>
            </template>
            <template v-if="modelType === '2'">
              <dt>总体性能:</dt>
              <dd>{{ JSON.parse(item.reportData).mAP | toPercent }}</dd>
            </template> -->
          </dl>
          <dl class="meta dataset">
            <dt>数据集:</dt>
            <dd>
              <span @click="toDatasetVersion(item)">{{ item.datasetVersionName }}</span>
              <!-- <span>{{ item.datasetName }}</span> -->
              <span v-if="modelType == 1 || modelType == 2">有效{{modelType == 2?'已标注':''}}图片数 {{ item.imgNum }} 张</span>
              <span v-if="modelType == 3 || modelType == 4">有效文本{{modelType==4?'标注':''}}数 {{ item.textNum }} 个</span>
              <span v-if="modelType == 5 || modelType == 6">有效音频{{modelType==6?'标注':''}}数 {{ item.audioNum }} 个</span>
            </dd>
          </dl>
          <dl class="meta">
            <dt>训练时间:</dt>
            <!-- TODO:需要一个时间格式库处理 -->
            <!-- <dd>201907-19 10:25:16</dd> -->
            <dd>
              {{ item.trainBeginTime || item.trainEndTime | moment("YYYY-MM-DD HH:mm:ss") }}
            </dd>
          </dl>
          <dl class="meta">
            <dt>{{ item.trainModelStatus | trainModelStatusTransform }}</dt>
            <!-- 倒计时 -->
            <!-- <span v-if="item.trainModelStatus == 1">预计需要{{item.remainingTime}}分钟</span> -->
            <span v-if="item.trainModelStatus == 1">预计{{estimatedTime(item.remainingTime, idx)}}完成</span>
            <dd class="btn-opt">
              <button
                @click="onSwitchCommonStatus(item.trainModelId, item.isPublic)"
                v-show="item.trainModelStatus === 3 && userRole == 4"
              >
                {{item.isPublic == 1 ? '已公开' : '未公开'}}
              </button>
              <button
                @click="
                  trainingCommand([
                    'release',
                    item.modelId,
                    item.trainModelId,
                    idx,
                    item.version
                  ])
                "
                v-show="item.trainModelStatus === 2"
              >
                申请发布
              </button>
              <button
                @click="
                  trainingCommand([
                    'verify',
                    item.modelId,
                    item.trainModelId,
                    idx,
                    item.version
                  ])
                "
                v-show="item.trainModelStatus > 1 && item.trainModelStatus < 4"
              >
                校验
              </button>
              <button
                @click="activeDeletePopup(item.trainModelId, idx)"
                v-if="item.trainModelStatus !== 3"
              >
                删除
              </button>
            </dd>
          </dl>
          <button
            class="btn-download-model"
            @click="downloadModel(item.trainModelInfo)"
            v-if="item.trainModelInfo && item.trainModelStatus !== 5"
          >
            下载模型
          </button>
          <button
            class="btn-evaluate"
            @click="activeReportData(item, idx)"
            v-if="item.reportData && item.trainModelStatus !== 5"
          >
            评估报告
          </button>
        </div>

        <!-- <div class="evaluate-report"></div>  -->
      </div>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          background
          :current-page.sync="currentPage"
          :page-size="10"
          :pager-count="5"
          layout="slot, prev, pager, next"
          :total="totalCount"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 弹窗集 -->
    <div class="popup-list">
      <!-- 下载模型 -->
      <gat-popup
        :class="['popup-download-model', popupActive === 'downloadModel' ? 'on' : 'off']"
        :title="'下载模型'"
        @cancel="cancelPopup"
        @confirm="canceldownloadModel"
      >
        <template v-slot:content>
          <div class="model-data">
            <div class="model-data-th">
              <span>名称</span>
              <span>大小</span>
            </div>
            <!-- <div class="model-data-tr">
              <span>kaolayehuizhamaokaolayehuizhamaokaolayehuizhamao</span>
              <span>40KB</span>
            </div>
            <div class="model-data-tr">
              <span>hongshaoshizitou</span>
              <span>87.36MB</span>
            </div> -->
            <div class="model-data-tr" v-for="(item, index) in trainModelInfo" :key="index">
              <span>{{item.name}}</span>
              <span>{{item.size}}</span>
            </div>
          </div>
        </template>
      </gat-popup>

      <!-- 评估报告 -->
      <gat-popup
        :class="['popup-report', popupActive === 'report_data' ? 'on' : 'off']"
        :title="'评估报告'"
        @cancel="cancelPopup"
        @confirm="cancelPopup"
      >
        <template v-slot:content>
          <div class="progress">
            <figure class="figure">
              <!-- <icon-base v-bind="Icons.ProgressCircle">
                <progress-circle
                  :num="
                    popupData.report
                      ? popupData.report.mAP || popupData.report.Accuracy
                      : 0
                  "
                />
              </icon-base> -->
              <icon-base v-bind="Icons.ProgressCircle">
                <progress-circle
                  :num="popupData.report ? popupData.report.mAP || popupData.report.Accuracy : 0"
                  :numName="modelType == 1 || modelType == 3 || modelType == 5 ? 'Accuracy' : 'mAP'"
                />
              </icon-base>
              <figcaption>
                <template v-if="modelType == 1 || modelType == 3 || modelType == 5">
                  {{ "Accuracy" | strTrasform }}
                </template>
                <template v-if="modelType == 2 || modelType == 4 || modelType == 6">
                  {{ "mAP" | strTrasform }}
                </template>
              </figcaption>
            </figure>
          </div>

          <span></span>
        </template>
      </gat-popup>

      <!-- 创建/修改模型 -->
      <gat-popup
        :class="['popup-update', popupActive === 'create' || popupActive === 'update' ? 'on' : 'off']"
        :title="popupActive === 'create' ? '创建模型' : '模型修改'"
        :primary-button="'确定'"
        @cancel="cancelPopup"
        @confirm="updateModel"
      >
        <template v-slot:content>
          <div class="intxt">
            <span class="label"><i class="required">*</i>模型名称：</span>
            <el-input
              placeholder="请输入模型名称"
              v-model.trim="popupData.update.modelName"
              maxlength="20"
              show-word-limit
            />
          </div>
          <div class="intxt">
            <span class="label"><i class="required">*</i>模型描述：</span>
            <el-input
              v-model.trim="popupData.update.modelFuncDesc"
              type="textarea"
              :rows="6"
              maxlength="200"
              show-word-limit
              placeholder="请输入模型描述"
            />
          </div>
        </template>
      </gat-popup>

      <!-- 删除模型 -->
      <gat-popup
        :class="['popup-delete', popupActive === 'delete' ? 'on' : 'off']"
        :title="''"
        :primary-button="'删除'"
        @cancel="cancelPopup"
        @confirm="deleteModel"
      >
        <template v-slot:content>
          <div class="popup-del-cnt">
            <div class="head">
              <i class="icon-box">
                <icon-base
                    class="icon-info-help"
                    :icon-name="Icons.InfoHelp.iconName"
                    v-bind="Icons.InfoHelp"
                >
                  <icon-info-help class="path-icon-info-help" />
                  <icon-info-help class="path-icon-info-help" />
                </icon-base>
              </i>
               <span class="title">确定删除此模型吗？</span>
            </div>

            <div class="content">删除后可在 “回收站” 恢复哦</div>
          </div>
        </template>
      </gat-popup>

      <!-- 删除模型版本 -->
      <gat-popup
        :class="[
          'popup-delete popup-delete-2',
          popupActive === 'delete-edition' ? 'on' : 'off'
        ]"
        :title="''"
        :primary-button="'删除'"
        @cancel="cancelPopup"
        @confirm="deleteTrainingModel"
      >
        <template v-slot:content>
          <div class="popup-del-cnt">
            <div class="head">
              <i class="icon-box">
                <icon-base
                  class="icon-info-help"
                  :icon-name="Icons.InfoHelp.iconName"
                  v-bind="Icons.InfoHelp"
                >
                  <icon-info-help class="path-icon-info-help" />
                  <icon-info-help class="path-icon-info-help" />
                </icon-base>
              </i>
              <span class="title">
                {{
                  display === "model"
                    ? "确定删除此模型吗？"
                    : "确定删除此版本模型吗？"
                }}
              </span>
            </div>
            <!-- <div class="content">
              删除后将无法恢复
            </div> -->
          </div>
        </template>
      </gat-popup>
    </div>
  </div>
</template>

<script>
import GatPopup from "@/components/common/GatPopup";
import IconSearch from "@/components/icons/typography/Search";
import IconInfoHelp from "@/components/icons/typography/InfoHelp";
import ProgressCircle from "@/components/icons/typography/ProgressCircle";
import PRETRAIN from "@/axios/pretrain/pretrain.js";
import { mapGetters } from "vuex";

export default {
  inject: ['reload'],
  name: "model-list",
  components: { GatPopup, IconSearch, IconInfoHelp, ProgressCircle },
  filters: {
    // 如果是 小于或等于 0 则显示 --
    striping(value) {
      var result = value;
      if (value <= 0) {
        result = "--";
      } else if (isNaN(value)) {
        result = "NaN";
      }

      return result;
    },
    // 训练模型状态处理
    trainModelStatusTransform(value) {
      var status = ["", "训练进行中", "训练完成", "已发布", "已下线", "训练失败"];
      return status[value];
    },
    // 转化为百分比
    toPercent(value) {
      var val = value,
        result = val <= 1 && val >= 0 ? val * 100 : val;
      return parseFloat(Number(result).toFixed(2)) + "%";
    },
    strTrasform(value) {
      // 标注：{"mAP":0.01}
      // 分类：{"Accuracy":0.01}
      var strs = {
        mAP: "总体性能",
        Accuracy: "准确率"
      };

      return strs[value];
    }
  },
  data() {
    return {
      userRole: 2, // 角色： 2-学生、1-老师、3-校管理员、4-超级管理员
      photoBaseUrl: window.gtaAiConfig.photoDomain, // 新UC资源基地址
      modelDomain: window.gtaAiConfig.modelDomain, // 储存模型服务器地址
      intervalTime: [],
      Model: {
        records: [],
        current: 1,
        size: 10,
        total: 0
      },
      TrainingModel: {
        records: [],
        current: 1,
        size: 10,
        total: 2
      },
      pageIndex: 1,
      currentPage: 1,
      popupActive: "",
      popupData: {
        update: {
          modelId: "",
          index: -1,
          modelFuncDesc: "",
          modelName: ""
          // isRelease: 0, // 是否已经发布
        },
        report: null
      },
      display: "model", // 显示模式，model 模型列表，version 模型版本列表
      key: "", // 搜索关键字
      activeModel: -1, // 跳转到版本列表里面的模型
      activeModelId: '', // 跳转到版本列表里面的模型id
      Icons: {
        search: {
          iconName: "搜索",
          viewBox: "0 0 20 20",
          width: "20",
          height: "20"
        },
        InfoHelp: {
          iconName: "",
          viewBox: "0 0 36 36",
          width: "36",
          height: "36"
          // iconColor: "#fff"
        },
        ProgressCircle: {
          iconName: "",
          viewBox: "0 0 120 120",
          width: "120",
          height: "120"
        }
      },
      trainModelInfo: [], // 下载模型文件数据
      tableData1: [
        {
          datasetName : '我是数据集',
          versionNumber: 'V1',
          totalData: '44',
          annotated: '120',
          labelNumber: '3',
          labelName: 'A、B、C',
        }, {
          datasetName : '我是数据集',
          versionNumber: 'V1',
          totalData: '44',
          annotated: '120',
          labelNumber: '3',
          labelName: 'A、B、C',
        }, {
          datasetName : '我是数据集',
          versionNumber: 'V1',
          totalData: '44',
          annotated: '120',
          labelNumber: '3',
          labelName: 'A、B、C',
        }
      ],
      timeMinutes: '',
      htmlTitle: "PDF名称",
      nowTime: "",
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    totalCount() {
      return this.display === "model"
        ? this.Model.total
        : this.TrainingModel.total;
    },
    modelType() {
      return this.$route.params.modeltype;
    },
    ...mapGetters(["accountInfo"])
  },
  watch: {
    $route(to, from) {
      // console.log(to);
      // console.log(from);
    },
    token() {
      // this.getModelPageList().then(this.releaseAfterToversionVisible);
    },
    display(val) {
      this.currentPage =
        val === "model" ? this.Model.current : this.TrainingModel.current;
    },
    // TrainingModel(newTrainingModel, oldTrainingModel) {
    //   var index = this.popupData.update.index,
    //     models,
    //     modelId,
    //     targetModelIndex;

    //   if (newTrainingModel.total < oldTrainingModel.total) {
    //     modelId = oldTrainingModel.records[index].modelId;

    //     models = JSON.parse(JSON.stringify(this.Model));

    //     targetModelIndex = models.records.findIndex(
    //       item => item.modelId === modelId
    //     );
    //     models.records[targetModelIndex].version -= 1;
    //     this.Model = models;
    //   }
    // }
  },
  created() {
    // 获取用户身份（老师/学生/管理员）
    this.userRole = this.$store.state.userRole;

    if (this.$route.query.activeModelId) {
      let modelId = this.$route.query.activeModelId || '';
      let index = this.$route.query.activeModel || -1;
      this.versionVisible(modelId, index);
    }
  },
  mounted() {
    // TODO:token 未到
    if (this.token) {
      if (localStorage.modelPageIndex) {
        let pageIndex = Number(localStorage.modelPageIndex) || 1;
        this.getModelPageList(pageIndex).then(this.releaseAfterToversionVisible);
        localStorage.modelPageIndex = ''
      } else {
        this.getModelPageList().then(this.releaseAfterToversionVisible);
      }
    }
  },
  methods: {
    // 计算时间差
    // calculationTimeDifference(time1, time2) {
    //   // 时间格式'yy-MM-dd hh:mm:ss' 转换时间戳
    //   var timestamp1 = Date.parse(new Date(time1));
    //   var timestamp2 = Date.parse(new Date(time2));
    //   var timeDifference = timestamp2 - timestamp1;
    //   // 时间戳转换分钟
    //   var currentdate = timeDifference/1000/60;
    //   // parseFloat(去除小数点后多余的0) toFixed(保留n位小数)
    //   currentdate = parseFloat(currentdate.toFixed(2));
    //   return currentdate;
    // },
    // 时间戳转日期时间格式'yy-MM-dd hh:mm:ss'
    getdate(val) {
      var date = new Date(val);
      var YY = date.getFullYear() + '-';
      var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
      var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
      return YY + MM + DD +" "+hh + mm + ss;
    },
    // 返回预计时间格式
    estimatedTime(val, index) {
      var date = new Date();
      var timeStamp = date.getTime(); // 当前时间戳
      var addMinutes = val * 60 * 1000; // 预计时间戳
      var estimatedTimeStamp = timeStamp + addMinutes;

      var currentdate = this.getdate(estimatedTimeStamp);
      // console.log('当前时间',currentdate)
      return currentdate;
    },
    // 预计时间倒计时
    countDown(val, index) {
      let time = val
      var intervalTime = null;
      intervalTime = setInterval(()=>{
        --time
        // this.$set(this.TrainingModel.records[index], 'remainingTime', time)
        if (time === 0) {
          for (var i = 0; i < this.intervalTime.length; i++) {
            clearInterval(this.intervalTime[i]);
          }
          this.intervalTime.splice(0, this.intervalTime.length);

          let modelId = this.Model.records[this.activeModel].modelId;
          // this.getTrainingModels(modelId, this.activeModel, this.pageIndex);
          this.getTrainingModels(modelId, this.pageIndex);
        }
      }, 60000)
      this.intervalTime.push(intervalTime)
    },
    toDatasetVersion(item){
        this.operateRedirect(item)
    },
      // 分类、标注跳转
    operateRedirect(dataset /*, idx*/) {
      var route = {},
        modelType = this.modelType,
        {datasetId,datasetName,datasetExist}=dataset;
      // console.log('datasetId--',datasetId)
      // datasetExist 数据集 0存在 1在回收站 2完全被删
      if(datasetExist !=0){
       return this.$message.warning(`${datasetName}已被删除，请先恢复再查看`)
      }

      if (modelType == 1) {
        // 图片分类
        route.name = 'dataset-classify'
      } else if (modelType == 2) {
        // 物体检测
        route.name = 'dataset-label'
      } else if (modelType == 3) {
        // 文本分类
        route.name = 'dataset-categorization'
      } else if (modelType == 4) {
        // 文本标注
        route.name = 'dataset-annotation'
      } else if (modelType == 5) {
        // 音频分类
        route.name = 'dataset-audioCategorization'
      } else if (modelType == 6) {
        // 音频标注
        route.name = 'dataset-audioAnnotation'
      }
      route.params = {}
      route.params.modeltype = modelType
      route.params.datasetId = datasetId
      route.params.datasetName = datasetName
      route.params.origin = 'modelList'
      // console.log('route',route)
      this.$router.push(route)
    },
    // 超级管理员切换公开模型是否公开状态
    onSwitchCommonStatus(id, val) {
      let data = {
        trainModelId: id,
        isPublic: val == 1 ? 0 : 1
      }
      PRETRAIN.updateIsPublic(data).then(result => {
        if (result.isSuccess || result.returnCode == 200) {
          this.$message.success(result.returnMsg);
          let modelId = this.Model.records[this.activeModel].modelId;
          // this.getTrainingModels(modelId, this.activeModel, this.pageIndex);
          this.getTrainingModels(modelId, this.pageIndex);
        } else {
          this.$message.error(result.returnMsg);
        }
      });
    },
    /**
     * 接口：查询当前账号下我的模型列表  @data "modelName":模型名称 ;type 模型类型;"pageNum" ;  "pageSize"
     */
    getModelPageList(pageIndex, key) {
      var pageIndex_ = pageIndex ? pageIndex : this.Model.current,
        pageSize = this.Model.size,
        modeltype = Number(this.$route.params.modeltype),
        accountInfo = this.accountInfo,
        modelName = "",
        data = {
          type: modeltype,
          modelName: modelName,
          pageNum: pageIndex_,
          pageSize: pageSize
        };
      if (key) {
        data.modelName = key;
      }
      return new Promise((resolv, reject) => {
        PRETRAIN.getMyModelList(data).then(result => {
          if (result.isSuccess || result.returnCode == 200) {
            this.Model = result.data;
            resolv(result.data);
            this.$forceUpdate() // 强制更新数据
          } else {
            reject(result);
          }
        });
      });
    },
    // 版本信息查看我的模型
    getTrainingModels(modelId, pageIndex) {
      // var model = this.Model.records[index];
      let type = this.modelType,
        pageIndex_ = pageIndex ? pageIndex : 1,
        data = {
          modelId: modelId,
          type: type,
          pageNum: pageIndex_,
          pageSize: 10
        };

      PRETRAIN.getTrainModelByModelId(data).then(result => {
        if (result.isSuccess) {
          this.TrainingModel = result.data;
          this.TrainingModel.records.forEach((item, index) => {
            if(item.remainingTime > 0) {
              this.countDown(item.remainingTime, index) // 预计时间倒计时
            }
          });
        }
      });
    },
    versionVisible(modelId, index) {
      // TODO:此处需要调用 Mod_training_model
      // 版本信息查看，尝试利用 route query
      this.display = "version";
      this.activeModel = index;
      this.activeModelId = modelId

      // this.getTrainingModels(modelId, index, 1);
      this.getTrainingModels(modelId, 1);
    },
    // 下载模型
    downloadModel(val) {
      // console.log(JSON.parse(val))
      if (val) {
        let trainModelInfo = JSON.parse(val)
        this.trainModelInfo = []
        let label = {
          name: trainModelInfo.label_name,
          size: trainModelInfo.label_size + 'B',
          path: this.modelDomain + '/' + trainModelInfo.remote_label_path
        }
        let model = {
          name: trainModelInfo.model_name,
          size: trainModelInfo.model_size + 'MB',
          path: this.modelDomain + '/' + trainModelInfo.remote_model_path
        }
        this.trainModelInfo.push(label)
        this.trainModelInfo.push(model)
  
        this.popupActive = 'downloadModel'
      }
      console.log(this.trainModelInfo)
    },
    // 确定下载模型
    canceldownloadModel() {
      this.cancelPopup();// 关闭弹窗
      this.trainModelInfo.forEach(item => {
        if (item.path) {
          // console.log('path ==== ',item.path)
          this.downFile(item.path)
        }
      });
    },
    // 可遍历此方法同时下载多个文件
    downFile(url){
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";  // 防止影响页面
      iframe.style.height = 0;  // 防止影响页面
      iframe.src = url;
      document.body.appendChild(iframe);  // 这一行必须，iframe挂在到dom树上才会发请求
      // 5分钟之后删除（onload方法对于下载链接不起作用）
      setTimeout(()=>{
        iframe.remove();
      }, 5 * 60 * 1000);
    },
    // 评估报告显示
    activeReportData(val, index) {
      if (this.modelType == 1 || this.modelType == 2) {
        this.$router.push({
          name: 'model-assessment-report', 
          query: {
            // display : this.display,
            activeModel: this.activeModel.toString(),
            activeModelId: this.activeModelId,
            datasetType: this.modelType, // 数据集类型：1图像分类，2图像检测，3文本分类，4文本标注，5音频分类，6音频标注
            trainModelId: val.trainModelId, // 训练模型id
          }
        })
      } else {
        var trainingModel = this.TrainingModel.records[index],
          JSONReportData = trainingModel.reportData,
          reportData = JSON.parse(JSONReportData);
  
        this.popupData.report = reportData;
        this.popupActive = "report_data";
      }
    },
    // 发布模型之后跳转过来使用
    releaseAfterToversionVisible() {
      var display, modelId, index;
      if (this.$route.query.display) {
        display = this.$route.query.display;
        modelId = this.$route.query.modelId;
        index = this.Model.records.findIndex(item => item.modelId === modelId);
        this.display = display;
        this.activeModel = index;
        // console.log("this.Model",this.Model.records, index);
        this.getTrainingModels(modelId, 1);
      }
    },
    // 下拉点击
    trainingCommand(command) {
      // command：[operate, modelId, trainingModelId, index]
      var modeltype = this.$route.params.modeltype,
        route = {
          name: "model-operate",
          params: {
            modeltype: modeltype,
            version: command[4]
          },
          query: {
            operate: command[0],
            modelId: command[1]
          }
        };

      if (command[2]) {
        route.query.trainingModelId = command[2];
      }
      this.$router.push(route);
    },
    // 新建模型跳转
    createModel() {
      this.popupData = {
        update: {
          modelId: "",
          index: -1,
          modelFuncDesc: "",
          modelName: ""
          // isRelease: 0, // 是否已经发布
        },
        report: null
      };
      this.popupActive = 'create';
      // var params = this.$route.params,
      //   params_ = Object.assign({}, params),
      //   query_ = {};

      // query_.operate = "create";

      // this.$router.push({
      //   name: "model-operate",
      //   params: params_,
      //   query: query_
      // });
    },
    // 模型删除激活
    activeDeletePopup(modelId, index) {
      if (this.display === "version") {
        this.popupActive = "delete-edition";
      } else if (this.display === "model") {
        this.popupActive = "delete";
      }
      this.popupData.update.modelId = modelId;
      this.popupData.update.index = index;
    },
    /**
     * 删除模型  @data modelFuncDesc模型功能描述 modelName模型名称  modelId模型id
     */
    deleteModel() {
      // TODO:删除模型
      var modelId = this.popupData.update.modelId,
        index = this.popupData.update.index,
        model = this.Model.records[index],
        modelName = model.modelName,
        isRelease = model.IsContainPublishedModel, // 是否已经发布
        data = {
          modelName: modelName,
          modelId: modelId
          // isDeleted: 1
        };

      // 关闭弹窗
      this.cancelPopup();
      if (isRelease) {
        return this.$message.error("删除失败，无法删除已发布版本的模型");
      }

      PRETRAIN.deleteModel(data).then(result => {
        if (result.isSuccess) {
          this.$message.success(result.returnMsg);
          if (this.pageIndex > 1 && this.Model && this.Model.records.length === 1) {
            this.pageIndex = this.pageIndex - 1
            this.getModelPageList(this.pageIndex);
          } else {
            this.getModelPageList(this.pageIndex);
          }
        } else {
          this.$message.error(result.returnMsg);
        }
      });
    },
    // 删除发布的训练模型版本
    deleteTrainingModel() {
      var index = this.popupData.update.index,
        trainingModel = this.TrainingModel.records,
        trainModelId = trainingModel[index].trainModelId,
        trainModelStatus = trainingModel[index].trainModelStatus,
        data = null,
        list;

      data = {
        trainModelId: trainModelId,
        trainModelStatus: trainModelStatus,
      };

      // 关闭弹窗
      this.cancelPopup();

      PRETRAIN.deleteTrainingModel(data).then(result => {
        if (result.isSuccess) {
          this.$message.success(result.returnMsg);
          list = JSON.parse(JSON.stringify(this.TrainingModel));
          list.records.splice(index, 1);
          list.total -= 1;
          this.TrainingModel = list;

          let modelId = this.Model.records[this.activeModel].modelId;
          if (this.pageIndex > 1 && list.records.length === 0) {
            this.pageIndex = this.pageIndex - 1
            this.getTrainingModels(modelId, this.pageIndex);
          } else {
            this.getTrainingModels(modelId, this.pageIndex);
          }
        } else {
          this.$message.error(result.returnMsg);
        }
      });
    },
    // 模型修改激活
    activeUpdatePopup(modelId, index) {
      var model = this.Model.records[index];
      this.popupActive = "update";
      // 弹窗数据传递
      this.popupData.update.modelId = modelId;
      this.popupData.update.index = index;
      this.popupData.update.modelName = model.modelName;
      this.popupData.update.modelFuncDesc = model.modelFuncDesc;
    },
    // 创建/修改模型 @data modelFuncDesc模型功能描述 modelName模型名称  modelId模型id
    updateModel() {
      // TODO:弹窗数据传递
      var index = this.popupData.update.index,
        modelId = this.popupData.update.modelId,
        modelName = this.popupData.update.modelName,
        modelFuncDesc = this.popupData.update.modelFuncDesc,
        modelType = this.modelType,
        data = {},
        items = [];

      if (!modelName || !modelFuncDesc) {
        return this.$message.error("请完整填写模型相关内容");
      }

      if (this.popupActive === 'create') {
        // var modeltype = this.$route.params.modeltype;
        data = {
          modelName: modelName,
          modelFuncDesc: modelFuncDesc,
          type: modelType
        };

        PRETRAIN.addModel(data).then(result => {
          if (result.isSuccess) {
            this.$message.success(result.returnMsg);

            this.getModelPageList(1);
            this.cancelPopup();
          } else {
            this.$message.error(result.returnMsg);
          }
        });

      } else {
        data = {
          modelName: modelName,
          modelId: modelId,
          modelFuncDesc: modelFuncDesc
        };
  
        PRETRAIN.updateModel(data).then(result => {
          if (result.isSuccess) {
            this.$message.success(result.returnMsg);
  
            // 更新缓存
            items = JSON.parse(JSON.stringify(this.Model.records));
            Object.assign(items[index], {
              modelName: modelName,
              modelFuncDesc: modelFuncDesc
            });
  
            this.Model.records = items;
            this.cancelPopup();
          } else {
            this.$message.error(result.returnMsg);
          }
        });
      }
    },
    // 取消弹窗
    cancelPopup() {
      this.popupActive = "";
      // TODO:弹窗数据传递
      // this.popupData = this.Model.records[idx];
    },
    // 分页器点击
    handleCurrentChange(pageIndex) {
      var modelId;
      this.pageIndex = pageIndex
      if (this.display === "model") {
        this.getModelPageList(pageIndex, this.key);
      } else {
        modelId = this.Model.records[this.activeModel].modelId;
        // this.getTrainingModels(modelId, this.activeModel, pageIndex);
        this.getTrainingModels(modelId, pageIndex);
      }
    },
    // 搜索
    searchByModelName() {
      this.display = "model";
      this.getModelPageList(this.Model.current, this.key);
    },
    // ExportSavePdf(htmlTitle, currentTime) {
    //   downloadPDF(this.$refs.pdf)
    // },
  }
};
</script>

<style lang="scss" scoped>
@import "./pretrain_common.scss";

$box_shadow: 0px 2px 6px 0px rgba(15, 15, 17, 0.05);
em {
  font-style: normal;
}

.model-list {
  box-shadow: $box_shadow;
  background: $background_content;
  position: relative;
  .header {
    .go-model {
      color: $active_color;
      cursor: pointer;
    }
    h3 {
      display: flex;
      align-items: center;
      // .modelName-span {
      //   max-width: 550px;
      //   overflow: hidden;
      //   text-overflow: ellipsis;
      //   -o-text-overflow: ellipsis;
      //   white-space: nowrap;
      // }
    }
    .tools {
      display: flex;
      .el-input {
        width: 240px;
        margin-right: 15px;
        &::v-deep .el-input__inner {
          height: 36px;
          border-color: #d9deea;
          border-radius: 0;
          &:hover {
            border-color: #d9deea;
          }
        }
      }
      .icon-search-box {
        vertical-align: -13px;
        padding-right: 5px;
        cursor: pointer;
      }
      .btn-create {
        color: #fff;
        height: 36px;
        font-size: 14px;
        background: $bgc_btn_primary;
        border-radius: 5px;
        padding: 0 10px;
        display: flex;
        align-items: center;
        cursor: pointer;
        i {
          font-size: 20px;
          margin-right: 5px;
        }
      }
      // .btn-create {
      //   position: relative;
      //   width: 32px;
      //   height: 32px;
      //   border: 0 none;
      //   outline: 0 none;
      //   border-radius: 50%;
      //   background-color: $bgc_btn_primary;
      //   cursor: pointer;
      //   &::before,
      //   &::after {
      //     display: inline-block;
      //     position: absolute;
      //     top: 0;
      //     right: 0;
      //     bottom: 0;
      //     left: 0;
      //     width: 16px;
      //     height: 2px;
      //     margin: auto;
      //     background-color: #fff;
      //     content: "";
      //   }
      //   &::after {
      //     transform: rotate(90deg);
      //   }
      //   &:hover,
      //   &:focus {
      //     background-color: $bgc_btn_primary_hover;
      //   }
      //   &:active {
      //     background-color: $bgc_btn_primary;
      //   }
      // }
    }
  }
  .main {
    padding: 20px;
    margin-bottom: 50px;
  }
  .pagination {
    padding: 0;
    position: absolute;
    bottom: 20px;
    right: 20px;
  }
  .tb-models {
    box-sizing: border-box;
    width: 100%;
    color: $font_333_color;
    font-size: $font_size;
    text-align: center;
    .tb-head {
      height: 50px;
      line-height: 50px;
      background-color: #f2f6ff;
    }
    tbody {
      tr {
        height: 50px;
        border-bottom: 1px solid #d6dcea;
        line-height: 50px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &.tb-body-r:hover {
          background-color: #f2f6ff;
        }
      }
    }
    .tb-name {
      overflow: hidden;
      text-overflow: ellipsis;
      box-sizing: border-box;
      min-width: 15em;
      width: 28em;
      max-width: 28em;
      padding: 0 30px;
      text-align: left;
      white-space: nowrap;
    }
    .tb-edition {
      min-width: 200px;
      .edition {
        color: #0dbe7e;
        &.off {
          cursor: default;
          pointer-events: none;
        }
      }
      &:empty::before {
        content: "--";
      }
    }
    .tb-action {
      min-width: 180px;
      width: 180px;
      .el-dropdown-link {
        color: #4c88ff;
      }
    }
    .sep {
      display: inline-block;
      height: 1em;
      width: 1px;
      margin: 0 10px;
      vertical-align: middle;
      background-color: #d6dcea;
    }
    .btn-opt {
      width: 37px;
      height: 37px;
      padding: 10px;
      border: 0 none;
      outline: 0 none;
      background: transparent;
      vertical-align: middle;
      line-height: 1;
      cursor: pointer;
      &:active {
        opacity: 0.85;
      }
      .icon_box {
        width: 17px;
        height: 17px;
        line-height: 1;
        &.icon-edi {
          // background: url("../../assets/images/ico_edite.png") no-repeat;
          background: url("../../assets/images/trainingCenter/icon_edit.png") no-repeat center;
          background-size: contain;
        }
        &.icon-del {
          // background: url("../../assets/images/ico_del.png") no-repeat;
          background: url('../../assets/images/trainingCenter/icon_delete.png') no-repeat center;
          background-size: contain;
        }
      }
    }
  }
  .model-version {
    button {
      border: 0 none;
      outline: 0 none;
      padding: 0;
      background-color: transparent;
      cursor: pointer;
      &:hover {
        opacity: 0.85;
      }
      &:active {
        opacity: 1;
      }
    }
    .version-list {
      position: relative;
      border-bottom: 1px solid $border_bottom_list;
      margin-top: 20px;
      &:first-child {
        margin-top: 0;
      }
      .meta {
        margin-bottom: 20px;
        font-size: $font_size;
        color: $font_333_color;
        dt,
        dd {
          display: inline-block;
        }
        dt {
          margin-right: 0.5em;
        }
        button {
          padding: 0 10px;
          margin: 0 2.5px;
          background-color: transparent;
          color: #3978f4;
        }
        &.dataset {
          span:first-child {
            margin-right: 1.5em;
            // color: #9013FE;
            color: $bgc_btn_primary;
            cursor: pointer;
          }
        }
      }
      .btn-download-model {
        position: absolute;
        top: -10px;
        right: 60px;
        padding: 10px;
        color: $active_color;
        font-weight: bold;
      }
      .btn-evaluate {
        position: absolute;
        top: -10px;
        right: -5px;
        padding: 10px;
        color: $active_color;
        font-weight: bold;
      }
    }
  }
  .popup-list {
    &::v-deep .popup-inner {
      height: 350px;
    }
    .popup-delete {
      &::v-deep .popup-inner {
        height: 200px;
      }
      .content {
        padding: 20px 0;
      }
    }
    .popup-download-model {
      &::v-deep .popup-inner {
        height: 260px;
      }
      .model-data {
        margin-top: 20px;
        .model-data-th,
        .model-data-tr {
          display: flex;
          padding: 10px 0;
          span {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis; 
            white-space: nowrap;
          }
        }
        .model-data-th {
          font-size: 16px;
        }
      }
    }
    .popup-report {
      &::v-deep .popup-inner {
        // width: 700px;
        // height: 660px;
        // .popup-buttons {
        //   display: none;
        // }
        text-align: center;
        .popup-content {
          padding: 30px 30px;
        }
      }
      .popup-content {
        height: calc(100% - 60px);
        #pdfCentent {
          height: 100%;
          h3 {
            color: #333;
            text-align: center;
            margin: -40px 0 20px;
          }
          .progress {
            // height: calc(100% - 60px);
            height: 530px;
            overflow-x: hidden;
            overflow-y: auto;
            .userName {
              color: #333;
              font-size: 14px;
              font-weight: 600;
              text-align: right;
            }
            .span-color-black {
              color: #333;
              font-weight: 600;
            }
            .span-color-ash {
              color: #666;
              font-size: 12px;
            }
            h4 {
              height: 16px;
              color: #4c88ff;
              border-left: 3px solid #4c88ff;
              font-size: 16px;
              line-height: 17px;
              padding-left: 6px;
              margin: 10px 0;
            }
            h6 {
              color: #4c88ff;
              font-size: 14px;
              margin: 5px 0;
            }
            p {
              font-size: 14px;
              line-height: 14px;
              margin: 5px 0;
              display: flex;
              flex-wrap: nowrap;
              span {
                flex: 1;
                // width: 50%;
                display: flex;
                padding: 0 6px;
                .text {
                  flex: 1;
                  word-break: break-all;
                  word-wrap: break-word;
                  white-space: pre-wrap;
                }
              }
            }
            .figure {
              display: flex;
              justify-content: space-between;
              figcaption {
                margin-top: 15px;
              }
            }
          }
          .pdf-visible {
            height: auto;
            overflow-y: visible;
          }
        }

        .div-buttons {
          position: absolute;
          bottom: 30px;
          left: 0;
          right: 0;
          margin: auto;
          text-align: center;
          padding: 0 30px;
          .el-button {
            width: 90px;
            height: 40px;
            // padding: 0 10px;
            &.el-button--primary {
              background: #4c88ff;
              border-color: #4c88ff;
              &:hover {
                background: #409EFF;
                border-color: #409EFF;
              }
            }
          }
        }
      }
    }
  }
}
.el-dropdown-menu {
  &::v-deep {
    .off {
      color: #999;
      pointer-events: none;
    }
    .el-dropdown-menu__item {
      white-space: nowrap;
    }
  }
}
</style>
